import * as React from 'react';

import styles from './divider.module.css';

export function Or() {
    return <div className={styles.divider}>or</div>;
}
